type MesPageBannerProps = {
  className?: string;
  title?: string;
};

const MesPageBanner = ({ className = "", title }: MesPageBannerProps) => {
  return (
    <div className={`tv-common-banner ${className}`.trim()}>
      {title ? (
        <div className="tv-common-banner-text">
          <h4>{title}</h4>
        </div>
      ) : null}
    </div>
  );
};

export default MesPageBanner;
